import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    OpportunityUserClient,
    OpportunityUserViewPaginatedResultDto,
    SearchAvailableOpportunityUsersParameters,
    SearchUsersForOpportunityParameters,
    UserView
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class OpportunityUserService {
    constructor(private readonly client: OpportunityUserClient) {}

    async search(body: SearchUsersForOpportunityParameters): Promise<OpportunityUserViewPaginatedResultDto> {
        return await lastValueFrom(this.client.opportunityUserSearchForOpportunity(body));
    }

    async delete(id: number): Promise<void> {
        return await lastValueFrom(this.client.opportunityUserDelete(id));
    }

    async quickSearch(body: SearchAvailableOpportunityUsersParameters): Promise<UserView[]> {
        return await lastValueFrom(this.client.opportunityUserSearchAvailable(body));
    }
}
